export default "__VITE_ASSET__CdFGJq6U__"